import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.22123 16.5001C5.39303 16.5001 3.83502 15.8722 2.5472 14.6165C1.25939 13.3607 0.615479 11.8219 0.615479 10.0001C0.615479 8.26168 1.23023 6.78284 2.45973 5.56361C3.68921 4.34439 5.18408 3.66363 6.94433 3.52133L5.12893 1.65976L6.18275 0.605957L9.82695 4.25016L6.18275 7.89436L5.12893 6.82516L6.90203 5.05206C5.57126 5.20846 4.4408 5.74659 3.51065 6.66646C2.58052 7.58634 2.11545 8.69757 2.11545 10.0001C2.11545 11.3963 2.61577 12.5787 3.6164 13.5473C4.61705 14.5158 5.82186 15.0001 7.23083 15.0001H9.75003V16.5001H7.22123ZM12.2501 7.90398V1.50016H20.5V7.90398H12.2501ZM12.2501 16.5001V10.0963H20.5V16.5001H12.2501ZM13.75 15.0001H19.0001V11.5963H13.75V15.0001Z",
      fill: "#2B3486"
    }, null, -1)
  ]))]))
}
export default { render: render }